import type { ContactInfo, ContactMessageCommand } from '@sirius/contracts';

import { request } from '../client';

/** Канали зв'язку для сторінки Contact: адреса підтримки, коли її задано. */
export const getContactInfo = (): Promise<ContactInfo> => request<ContactInfo>('/contact');

/** Звернення з форми — команді листом. Відповідь порожня (204). */
export const sendContactMessage = (command: ContactMessageCommand): Promise<void> =>
	request<void>('/contact', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(command),
	});
